import { useDispatch } from "react-redux";
import HotspotListItemPure from "./HotspotListItemPure";
import { addHotspotFromUI } from "../../redux";
import AddIcon from "remixicon-react/AddLineIcon";
import { iconSize } from "../../config";
import { getVersion } from "../../util/getVersion";
import { versions } from "../../util/constants";

export function AddHotspotButton() {
  const version = getVersion();
  const dispatch = useDispatch();
  const onClick = () => dispatch(addHotspotFromUI());
  if (version === versions.image) {
    return null;
  }
  return (
    <HotspotListItemPure
      // thumbnail="placeholder"
      // disabled={true}
      dashed={true}
      centered={true}
      onClick={onClick}
    >
      <AddIcon size={iconSize} style={{ marginRight: "8px" }} />
      Add hotspot
    </HotspotListItemPure>
  );
}
